import React from 'react'
import Link from 'gatsby-link'
import logo from '../images/logo.svg'
import '../layouts/index.css'

const Footer = ({ siteTitle }) => (
  <div>
    <div className="creditos">
        <div className="contiene_creditos">
            <span>Créditos</span>
            <ul>
                <li className="que">Edición de textos:</li>
                <li>Jaime Bernal, Andrés Corona y Adrián Segovia</li>
                <li className="que">Redes Sociales:</li>
                <li>Humberto Barboza y Diego Pinzón</li>
                <li className="que">Video:</li>
                <li>Diego Pinzón</li>
                <li className="que">Producto Digital:</li>
                <li>Oscar Rodríguez</li>
                <li className="que">Diseño:</li>
                <li>Jorge Lara</li>
                <li className="que">Desarrollo:</li>
                <li>Juan Jorge Hernández</li>
            </ul>
        </div>           
    </div>
  </div>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer.js